(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal-form"] && !Shopify.designMode) return;
  try {
    
  function loadWithdrawalTurnstile() {
    if (window.turnstile) {
      return Promise.resolve(window.turnstile);
    }

    if (window.jewelleryboxTurnstilePromise) {
      return window.jewelleryboxTurnstilePromise;
    }

    window.jewelleryboxTurnstilePromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(
        'script[data-jewellerybox-turnstile]'
      );

      if (existingScript) {
        if (window.turnstile) {
          resolve(window.turnstile);
          return;
        }

        existingScript.addEventListener(
          'load',
          () => resolve(window.turnstile),
          { once: true }
        );

        existingScript.addEventListener('error', reject, {
          once: true
        });

        return;
      }

      const script = document.createElement('script');

      script.src =
        'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

      script.async = true;
      script.defer = true;
      script.dataset.jewelleryboxTurnstile = 'true';

      script.addEventListener(
        'load',
        () => resolve(window.turnstile),
        { once: true }
      );

      script.addEventListener('error', reject, { once: true });

      document.head.appendChild(script);
    });

    return window.jewelleryboxTurnstilePromise;
  }

  function initialiseWithdrawalSection(root) {
    if (!root || root.dataset.withdrawalInitialised === 'true') {
      return;
    }

    const workerUrl = root.dataset.workerUrl;
    const locale = root.dataset.locale;
    const siteKey = root.dataset.siteKey;

    const strings = {
      submit: root.dataset.stringSubmit,
      submitting: root.dataset.stringSubmitting,
      turnstileWait: root.dataset.stringTurnstileWait,
      invalidOrder: root.dataset.stringInvalidOrder,
      defaultError: root.dataset.stringDefaultError
    };

    const modal = root.querySelector('.withdrawal-modal');
    const openButton = root.querySelector(
      '.withdrawal-section__open-button'
    );
    const closeButton = root.querySelector(
      '.withdrawal-modal__close'
    );
    const form = root.querySelector('[data-withdrawal-form]');
    const submitButton = root.querySelector(
      '[data-withdrawal-submit]'
    );
    const errorElement = root.querySelector(
      '.withdrawal-modal__error'
    );
    const successElement = root.querySelector(
      '[data-withdrawal-success]'
    );
    const infoElement = root.querySelector(
      '[data-withdrawal-info]'
    );
    const turnstileContainer = root.querySelector(
      '[data-turnstile-container]'
    );

    if (
      !modal ||
      !openButton ||
      !closeButton ||
      !form ||
      !submitButton ||
      !errorElement ||
      !successElement ||
      !infoElement ||
      !turnstileContainer
    ) {
      return;
    }

    root.dataset.withdrawalInitialised = 'true';

    let formOpenedAt = 0;
    let turnstileWidgetId = null;

    function showError(message) {
      errorElement.textContent = message;
      errorElement.hidden = false;
    }

    function clearError() {
      errorElement.textContent = '';
      errorElement.hidden = true;
    }

    function restoreSubmitButton() {
      submitButton.disabled = false;
      submitButton.textContent = strings.submit;
    }

    function resetTurnstile() {
      if (
        window.turnstile &&
        turnstileWidgetId !== null
      ) {
        try {
          window.turnstile.reset(turnstileWidgetId);
        } catch (error) {
          console.warn('Turnstile reset failed:', error);
        }
      }
    }

    function renderTurnstile() {
      if (turnstileWidgetId !== null) {
        return Promise.resolve(turnstileWidgetId);
      }

      return loadWithdrawalTurnstile().then((turnstile) => {
        if (!root.isConnected || turnstileWidgetId !== null) {
          return turnstileWidgetId;
        }

        turnstileWidgetId = turnstile.render(
          turnstileContainer,
          {
            sitekey: siteKey,
            theme: 'light'
          }
        );

        return turnstileWidgetId;
      });
    }

    function resetFormView() {
      form.reset();
      form.hidden = false;
      infoElement.hidden = false;
      successElement.hidden = true;

      clearError();
      restoreSubmitButton();
      resetTurnstile();
    }

    openButton.addEventListener('click', () => {
      resetFormView();

      formOpenedAt = Date.now();
      modal.showModal();

      renderTurnstile().catch(() => {
        showError(strings.defaultError);
      });
    });

    closeButton.addEventListener('click', () => {
      modal.close();
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.close();
      }
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      clearError();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = strings.submitting;

      const emailInput = form.elements.namedItem('email');
      const orderInput = form.elements.namedItem('order_number');
      const messageInput = form.elements.namedItem('message');
      const websiteInput = form.elements.namedItem('website');

      const orderNumber = orderInput.value.trim().toUpperCase();

      if (!/^J\d{6}$/.test(orderNumber)) {
        showError(strings.invalidOrder);
        restoreSubmitButton();
        return;
      }

      let turnstileToken = '';

      if (
        window.turnstile &&
        turnstileWidgetId !== null
      ) {
        turnstileToken =
          window.turnstile.getResponse(turnstileWidgetId) || '';
      }

      if (!turnstileToken) {
        showError(strings.turnstileWait);
        restoreSubmitButton();
        return;
      }

      const payload = {
        email: emailInput.value.trim(),
        order_number: orderNumber,
        message: messageInput.value.trim(),
        website: websiteInput.value,
        time_on_form: Date.now() - formOpenedAt,
        turnstile_token: turnstileToken,
        locale: locale
      };

      try {
        const response = await fetch(workerUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(data.error || strings.defaultError);
        }

        form.hidden = true;
        infoElement.hidden = true;
        successElement.hidden = false;
      } catch (error) {
        showError(error.message || strings.defaultError);
        restoreSubmitButton();
        resetTurnstile();
      }
    });
  }

  function initialiseWithdrawalSections(container = document) {
    if (container.matches?.('[data-withdrawal-section]')) {
      initialiseWithdrawalSection(container);
    }

    container
      .querySelectorAll('[data-withdrawal-section]')
      .forEach(initialiseWithdrawalSection);
  }

  initialiseWithdrawalSections();

  document.addEventListener('shopify:section:load', (event) => {
    initialiseWithdrawalSections(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
